// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"5bcdd8c8","331":"f09a0963","589":"50c25a66"}[chunkId] + ".chunk.js";
};